import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41571815")

_pushScopeId("data-v-41571815")
const _hoisted_1 = {
  class: "teacher-experiment",
  ref: "teacherExperiment"
}
const _hoisted_2 = {
  key: 0,
  class: "experiment-list-assign-container flex"
}
const _hoisted_3 = { class: "experiment-list-item-info" }
const _hoisted_4 = {
  key: 1,
  class: "log-list-assign-container"
}
const _hoisted_5 = { class: "text-ellipsis" }
const _hoisted_6 = { class: "flex align-items-center justify-center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, "实验时间", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, "实验内容", -1)
const _hoisted_9 = { class: "flex align-items-center justify-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "操作", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "删除未开始状态实验学生将无法进行该实验；进行中状态实验不可删除；若删除已结束状态实验，则该状态实验所有相关数据将一并删除且无法找回。", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "自由练习实验可提前结束实验，若结束实验时存在正在进行实验的学生，则该实验将无法继续，且未完成实验数据无法留存。", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("删除实验"))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("延续分配"))
const _hoisted_16 = {
  key: 0,
  class: "experiment-list-assign-pagination flex flex-row-reverse justify-between"
}
const _hoisted_17 = {
  key: 1,
  class: "log-list-assign-pagination flex flex-row-reverse justify-between"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { style: {"margin":"0 10px"} }, "到", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "align-center" }, "将删除本实验全部数据，是否确认删除？", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "align-center" }, "提前结束后学生将无法完成该实验，是否确认提前结束？", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_pagination = _resolveComponent("a-pagination")
  const _component_ManagementFrame = _resolveComponent("ManagementFrame")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_checkbox_for_class = _resolveComponent("checkbox-for-class")
  const _component_a_range_picker = _resolveComponent("a-range-picker")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_modal = _resolveComponent("a-modal")
  const _component_my_modal = _resolveComponent("my-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ManagementFrame, {
      items: _ctx.controllerModule.titleList,
      onClick: _ctx.controllerModule.handleTagClick
    }, {
      controllers: _withId(() => [
        _createVNode(_component_SvgIcon, {
          class: "my-icon",
          icon: "back",
          onClick: _ctx.controllerModule.handleBackClick
        }, null, 8, ["onClick"])
      ]),
      content: _withId(() => [
        (_ctx.controllerModule.tabIndex.value)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customCaseModule.customCaseModule.list, (item) => {
                return (_openBlock(), _createBlock("div", {
                  class: "experiment-list-item",
                  onClick: ($event: any) => (_ctx.experimentModule.handleEditClick(item))
                }, [
                  _createVNode("img", {
                    class: "experiment-list-item-img",
                    src: item.caseImg,
                    draggable: "false"
                  }, null, 8, ["src"]),
                  _createVNode("div", _hoisted_3, [
                    _createVNode("p", {
                      title: item.caseName
                    }, _toDisplayString(item.caseName), 9, ["title"]),
                    _createVNode("p", {
                      title: item.caseInfomation
                    }, _toDisplayString(item.caseInfomation), 9, ["title"])
                  ])
                ], 8, ["onClick"]))
              }), 256))
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_a_table, {
                class: "teacher-list-table",
                columns: _ctx.experimentModule.columns,
                "data-source": _ctx.experimentModule.experimentModule.list,
                pagination: false,
                rowKey: "id"
              }, {
                status: _withId(({record}) => [
                  _createVNode("span", null, _toDisplayString(record.status === 0 ? "未开始" : record.status === 1 ? "进行中" : "已结束"), 1)
                ]),
                classId: _withId(({record}) => [
                  _createVNode("div", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(record.classIds, (item) => {
                      return (_openBlock(), _createBlock("span", {
                        key: item,
                        title: _ctx.experimentModule.showClassName(item)
                      }, _toDisplayString(_ctx.experimentModule.showClassName(item)), 9, ["title"]))
                    }), 128))
                  ])
                ]),
                experimentModel: _withId(({record}) => [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", null, _toDisplayString(record.experimentModel === 0 ? "自由练习" : "考核模式"), 1),
                    _createVNode(_component_a_tooltip, {
                      placement: "rightTop",
                      overlayClassName: "experimentModel-tooltip",
                      getPopupContainer: () => _ctx.$refs.teacherExperiment
                    }, {
                      title: _withId(() => [
                        _createVNode("div", null, [
                          _hoisted_7,
                          _createVNode("span", null, _toDisplayString(`${record.beginTime} 至 ${record.endTime}`), 1),
                          _hoisted_8,
                          _createVNode("span", null, _toDisplayString(_ctx.experimentModule.showExperimentUnit(record.experimentalUnits)), 1)
                        ])
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_SvgIcon, {
                          class: "my-icon",
                          icon: "question"
                        })
                      ]),
                      _: 2
                    }, 1032, ["getPopupContainer"])
                  ])
                ]),
                operationTitle: _withId(() => [
                  _createVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_a_tooltip, {
                      placement: "rightTop",
                      overlayClassName: "experimentModel-tooltip",
                      getPopupContainer: () => _ctx.$refs.teacherExperiment
                    }, {
                      title: _withId(() => [
                        _hoisted_11,
                        _hoisted_12,
                        _hoisted_13
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_SvgIcon, {
                          class: "my-icon",
                          icon: "question"
                        })
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer"])
                  ])
                ]),
                operation: _withId(({record}) => [
                  (record.status === 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "link",
                        onClick: ($event: any) => (_ctx.experimentModule.handleDeleteClick(record.id))
                      }, {
                        default: _withId(() => [
                          _hoisted_14
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (record.status === 1)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "link",
                          disabled: record.experimentModel === 1,
                          onClick: ($event: any) => (_ctx.experimentModule.handleFinishClick(record.id))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(record.experimentModel === 1 ? "删除实验" : "提前结束"), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      : (_openBlock(), _createBlock(_component_a_button, {
                          key: 2,
                          type: "link",
                          disabled: record.continue,
                          onClick: ($event: any) => (_ctx.experimentModule.handleContinueClick(record))
                        }, {
                          default: _withId(() => [
                            _hoisted_15
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                ]),
                _: 1
              }, 8, ["columns", "data-source"])
            ]))
      ]),
      pagination: _withId(() => [
        (_ctx.controllerModule.tabIndex.value)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _createVNode(_component_a_pagination, {
                "show-quick-jumper": "",
                total: _ctx.customCaseModule.customCaseModule.totalRecords,
                pageSize: _ctx.customCaseModule.pagination.pageSize,
                current: _ctx.customCaseModule.pagination.pageNo,
                "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => (_ctx.customCaseModule.pagination.pageNo = $event)),
                onChange: _ctx.customCaseModule.handlePageChange
              }, null, 8, ["total", "pageSize", "current", "onChange"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode(_component_a_pagination, {
                "show-quick-jumper": "",
                total: _ctx.experimentModule.experimentModule.totalRecords,
                pageSize: _ctx.experimentModule.pagination.pageSize,
                current: _ctx.experimentModule.pagination.pageNo,
                "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => (_ctx.experimentModule.pagination.pageNo = $event)),
                onChange: _ctx.experimentModule.handlePageChange
              }, null, 8, ["total", "pageSize", "current", "onChange"])
            ]))
      ]),
      _: 1
    }, 8, ["items", "onClick"]),
    _createVNode(_component_a_modal, {
      title: "分配实验",
      width: "600px",
      bodyStyle: { maxHeight: "500px", overflowY: "scroll" },
      visible: _ctx.experimentModule.modalVisible.edit,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.experimentModule.modalVisible.edit = $event)),
      "confirm-loading": _ctx.experimentModule.modalConfirmLoading.edit,
      onCancel: _ctx.experimentModule.handleEditCancel,
      destroyOnClose: ""
    }, {
      footer: _withId(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.experimentModule.handleEditCancel
        }, {
          default: _withId(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          style: {"background-color":"#f5b34f","border-color":"#f5b34f","color":"#fff"},
          onClick: _ctx.experimentModule.handleEditOk,
          loading: _ctx.experimentModule.modalConfirmLoading.edit
        }, {
          default: _withId(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withId(() => [
        _createVNode(_component_a_form, {
          model: _ctx.experimentModule.editForm,
          labelCol: { span: 4, offset: 0 },
          wrapperCol: { span: 18, offset: 0 },
          labelAlign: "left"
        }, {
          default: _withId(() => [
            _createVNode(_component_a_form_item, { label: "实验名称" }, {
              default: _withId(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.experimentModule.editForm.experimentName,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.experimentModule.editForm.experimentName = $event)),
                  style: {"width":"256px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "实验内容" }, {
              default: _withId(() => [
                _createVNode(_component_a_select, {
                  "default-value": 0,
                  style: {"width":"160px"},
                  disabled: ""
                }, {
                  default: _withId(() => [
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.experimentModule.unitShowList.value[_ctx.experimentModule.getStartIndex()]), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_18,
                _createVNode(_component_a_select, {
                  "default-value": _ctx.experimentModule.unitShowList.value.length - 1,
                  style: {"width":"160px"},
                  onChange: _ctx.experimentModule.unitChange
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.experimentModule.unitShowList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        disabled: index < _ctx.experimentModule.getContinueIndex(),
                        value: index
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["default-value", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "选择班级" }, {
              default: _withId(() => [
                _createVNode(_component_checkbox_for_class, {
                  classList: _ctx.experimentModule.classModule.list,
                  onCheckChange: _ctx.experimentModule.checkChange,
                  disabled: _ctx.experimentModule.modalVisible.continue
                }, null, 8, ["classList", "onCheckChange", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "实验时间" }, {
              default: _withId(() => [
                _createVNode(_component_a_range_picker, {
                  valueFormat: "YYYY-MM-DD HH:mm:ss",
                  "disabled-date": _ctx.experimentModule.disabledDate,
                  placeholder: ["开始时间", "结束时间"],
                  showTime: "",
                  onChange: _ctx.experimentModule.dateOk
                }, null, 8, ["disabled-date", "onChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onCancel"]),
    _createVNode(_component_my_modal, {
      visible: _ctx.experimentModule.modalVisible.delete,
      loading: _ctx.experimentModule.modalConfirmLoading.delete,
      onOnCancel: _ctx.experimentModule.handleDeleteCancel,
      onOnOk: _ctx.experimentModule.handleDeleteOk
    }, {
      content: _withId(() => [
        _hoisted_21
      ]),
      _: 1
    }, 8, ["visible", "loading", "onOnCancel", "onOnOk"]),
    _createVNode(_component_my_modal, {
      visible: _ctx.experimentModule.modalVisible.finish,
      loading: _ctx.experimentModule.modalConfirmLoading.finish,
      onOnCancel: _ctx.experimentModule.handleFinishCancel,
      onOnOk: _ctx.experimentModule.handleFinishOk
    }, {
      content: _withId(() => [
        _hoisted_22
      ]),
      _: 1
    }, 8, ["visible", "loading", "onOnCancel", "onOnOk"])
  ], 512))
})